import styled from 'styled-components'
import Dropzone from 'react-dropzone'

export const BoxLink = styled(Dropzone)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-flow: wrap column;
  background-color: ${props => props.theme.colors.primary};

  & > i.fa,
  & > svg {
    color: ${props => props.theme.colors.white};
    font-size: 36px;
    margin-bottom: 10px;
  }
`

export const Text = styled.span`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: ${props => props.theme.colors.white};
`



// WEBPACK FOOTER //
// ./src/components/UploadImage/theme.js